import { styled } from '@mui/material';

export const ReportsVisitsSectionWidgetsContainer = styled('div')(
  ({ theme }) => ({
    display: 'grid',
    gap: theme.spacing(2),
    gridAutoRows: '1fr',
  }),
);
